import { isDev } from "../../../base/index.js";
import { notifyDefaultValuesSubscribers } from "./defaultValueSubscribers.js";
const __DEV__ = isDev();
const defaultValuesMap = /* @__PURE__ */ new Map();
function setDefaultValue(key, uid, value) {
  const values = defaultValuesMap.get(key) ?? [];
  if (values.length > 0) {
    if (__DEV__) {
      console.debug(
        `[tidal] useQueryState -- Trying to set a default values for ${key}, but its value has been already set to: ${values[0].value}`
      );
    }
  }
  values.push({ uid, value });
  defaultValuesMap.set(key, values);
  if (values.length === 1) {
    notifyDefaultValuesSubscribers(key, values[0].value);
  }
  return values[0].value;
}
function deleteDefaultValue(key, uid) {
  const values = defaultValuesMap.get(key);
  if (!values) return;
  const index = values.findIndex((v) => v.uid === uid);
  if (index > -1) {
    values.splice(index, 1);
  }
  if (values.length > 0) {
    if (__DEV__) {
      console.debug(`[tidal] useQueryState -- Default values for ${key} it's now set to: ${values[0]?.value}`);
    }
  }
  notifyDefaultValuesSubscribers(key, values[0]?.value);
  defaultValuesMap.set(key, values);
  return values[0]?.value;
}
function getDefaultValue(key) {
  return defaultValuesMap.get(key)?.[0]?.value;
}
export {
  deleteDefaultValue,
  getDefaultValue,
  setDefaultValue
};
//# sourceMappingURL=defaultValuesCache.js.map
